import React, { useState } from 'react';

import LogOutIcon from '@mui/icons-material/MeetingRoomOutlined';
import ProfileIcon from '@mui/icons-material/PersonOutline';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import { styled } from '@mui/material/styles';
import { getTranslate } from 'react-localize-redux';
import { Link } from 'react-router-dom';

import { useAppSelector } from '../../custom-hooks/useAppSelector';
import { displayName, gravatarUrl, initials } from '../../helpers/account';
import { accountRoutePaths } from '../../routes/accountRoutePaths';

const Holder = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

const StyledAvatar = styled(Avatar)({
  borderRadius: '10%',
});

const StyledMenu = styled(Menu)({
  zIndex: 1400,
});

const LogoutListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: theme.spacing(7),
}));

const PersonalDetails = styled(ListItemText)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
}));

const AppLessUserMenu = () => {
  const [anchor, setAnchor] = useState<Element>();
  const account = useAppSelector((state) => state.account);
  const translate = useAppSelector((state) => getTranslate(state.locale));
  const open = Boolean(anchor);

  const handleMenu = (event: React.MouseEvent) => {
    setAnchor(event.currentTarget);
  };

  const handleClose = () => {
    setAnchor(undefined);
  };

  return (
    <>
      <Holder data-fd="profile-icon">
        <IconButton
          aria-controls={open ? 'app-less-menu-appbar' : undefined}
          aria-haspopup="true"
          color="inherit"
          data-fd="profile-menu-btn"
          onClick={handleMenu}
        >
          <StyledAvatar variant="square" alt={displayName(account)} src={gravatarUrl(account)}>
            {initials(account)}
          </StyledAvatar>
        </IconButton>
      </Holder>

      <StyledMenu
        anchorEl={anchor}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
        id="app-less-menu-appbar"
        onClose={handleClose}
        open={open}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
      >
        <ListItem>
          <StyledAvatar variant="square" alt={displayName(account)} src={gravatarUrl(account)}>
            {initials(account)}
          </StyledAvatar>
          <PersonalDetails
            primary={displayName(account)}
            secondary={`${account.Email}`}
            data-fd="profile-name"
          />
        </ListItem>
        <ListItemButton
          component={Link}
          data-fd="profile-account"
          onClick={handleClose}
          sx={{ color: 'inherit', textDecoration: 'none' }}
          to={accountRoutePaths.MyAccount}
        >
          <ListItemIcon>
            <ProfileIcon />
          </ListItemIcon>
          <ListItemText primary={translate('My_account')} />
        </ListItemButton>
        <ListItemButton
          component={Link}
          data-fd="profile-logout"
          onClick={handleClose}
          sx={{ color: 'inherit', textDecoration: 'none' }}
          to={accountRoutePaths.Logout}
        >
          <LogoutListItemIcon onClick={handleClose}>
            <LogOutIcon />
          </LogoutListItemIcon>
          <ListItemText primary={translate('Logout')} />
        </ListItemButton>
      </StyledMenu>
    </>
  );
};

export default AppLessUserMenu;
